import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-media-management',
  templateUrl: './media-management.component.html',
  styleUrls: ['./media-management.component.scss'],
})
export class MediaManagementComponent implements OnInit {
  public dummyData: any[] = new Array(10).fill(0);

  constructor() {}

  ngOnInit(): void {}
}
